import {
  USERS_LOADING,
  USERS_SET_DATA,
  USERS_ERROR,
  USERS_REMOVE_DATA,
  ADD_CHATED_USER_START,
  ADD_CHATED_USER_SUCCESS,
  ADD_CHATED_USER_ERROR,
  LIST_CHATED_USER_ERROR,
  LIST_CHATED_USER_SUCCESS,
  LIST_CHATED_USER_START,
  CHAT_FETCH_START,
  CHAT_FETCH_SUCCESS,
  CHAT_FETCH_ERROR,
  REAL_TIME_CHAT
} from "./constants";
import { _fetchUsers, _addChatedPerson, _getChatedPerson, _getChats } from "./services";
import { errorParser } from '../../services/apiErrorParser';

/* Login actions */
export function userSetLoading(loading) {
  return {
    type: USERS_LOADING,
    payload: loading,
  };
}

export function userSetData(data) {
  return {
    type: USERS_SET_DATA,
    payload: data,
  };
}

export function userSetError(error) {
  return {
    type: USERS_ERROR,
    payload: error.message,
  };
}
export function userRemoveData(id) {
  return {
    type: USERS_REMOVE_DATA,
    payload: id,
  };
}

export const fetchUsers = () => (dispatch) => {
	return new Promise((resolve, reject) => {
		dispatch(userSetLoading(true));
		_fetchUsers().then(async (res) => {
			await dispatch(userSetData(res.data));
			resolve(res)
		}).catch((err) => {
			const parsedError = errorParser.parseError(err)
			dispatch(userSetError(parsedError));
			reject(err)
		}).finally(() => {
			dispatch(userSetLoading(false));
		})
	})
};

/**
 * Add chated user
 */
 const addChatedUserStart = data => {
   return {
    type: ADD_CHATED_USER_START,
    payload: data,
   }
 }
 const addChatedUserSuccess = data => {
  return {
   type: ADD_CHATED_USER_SUCCESS,
   payload: data,
  }
}
const addChatedUserError = error => {
  return {
   type: ADD_CHATED_USER_ERROR,
   payload: error,
  }
}

export const _addForChat = id => (dispatch) => {
	return new Promise((resolve, reject) => {
		dispatch(addChatedUserStart(true));
		_addChatedPerson(id).then(async (res) => {
			await dispatch(addChatedUserSuccess(res));
			resolve(res)
		}).catch((err) => {
			const parsedError = errorParser.parseError(err)
			dispatch(addChatedUserError(parsedError));
			reject(err)
		})
	})
};

/**
 * List chated User
 */
const listChatedUserStart = data => {
  return {
   type: LIST_CHATED_USER_START,
   payload: data,
  }
}
const listChatedUserSuccess = data => {
 return {
  type: LIST_CHATED_USER_SUCCESS,
  payload: data,
 }
}
const listChatedUserError = error => {
 return {
  type: LIST_CHATED_USER_ERROR,
  payload: error,
 }
}

export const _listedChatedUser = id => (dispatch) => {
 return new Promise((resolve, reject) => {
   dispatch(listChatedUserStart(true));
   _getChatedPerson(id).then(async (res) => {
     await dispatch(listChatedUserSuccess(res));
     resolve(res)
   }).catch((err) => {
     const parsedError = errorParser.parseError(err)
     dispatch(listChatedUserError(parsedError));
     reject(err)
   })
 })
};

/**
 * Chat fetch
 */
const fetchChatStart = data => {
  return {
   type: CHAT_FETCH_START,
   payload: data,
  }
}
const fetchChatSuccess = data => {
 return {
  type: CHAT_FETCH_SUCCESS,
  payload: data,
 }
}
const fetchChatError = error => {
 return {
  type: CHAT_FETCH_ERROR,
  payload: error,
 }
}

export const _chatList = id => (dispatch) => {
 return new Promise((resolve, reject) => {
   dispatch(fetchChatStart(true));
   _getChats(id).then(async (res) => {
     await dispatch(fetchChatSuccess(res));
     resolve(res)
   }).catch((err) => {
     const parsedError = errorParser.parseError(err)
     dispatch(fetchChatError(parsedError));
     reject(err)
   })
 })
};

/**
 * get realtime chat
 */
const updateRealtimeChatStart = data => {
  return {
   type: REAL_TIME_CHAT,
   payload: data,
  }
 }
export const updateRealtimeChatSuccess = data => {
  return {
   type: REAL_TIME_CHAT,
   payload: data,
  }
}

//  export const _updatechat = obj => (dispatch) => {
//   return new Promise(async(resolve, reject) => {
//     await dispatch(updateRealtimeChatSuccess(obj));
//     resolve(obj);
//   })
//  }